import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import MagicWandIcon from '@atlaskit/icon/core/magic-wand';
import { Flex } from '@atlaskit/primitives/compiled';
import { RangeField } from '@atlassian/company-hub-common';

import { CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE } from '../../../../../constants';
import type { CardsActions } from '../../../../../controllers/use-cards-extension-parameters-and-actions/types';
import type { CardsExtensionParameters } from '../../../../../types';

import { messages } from './messages';

type DynamicCardsContentProps = {
	extensionParameters: CardsExtensionParameters;
	extensionActions: CardsActions;
	viewFilters: () => void;
};
export const DynamicCardsContent = ({
	viewFilters,
	extensionParameters,
	extensionActions,
}: DynamicCardsContentProps) => {
	const { cardCount } = extensionParameters;
	const { updateMainFormField } = extensionActions;

	return (
		<>
			<Button shouldFitContainer appearance="primary" onClick={viewFilters}>
				<Flex gap="space.100" justifyContent="center">
					<MagicWandIcon label="" />
					<FormattedMessage {...messages.viewCurrentFilters} />
				</Flex>
			</Button>
			<RangeField
				analyticSource={CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE}
				label={messages.cardCountLabel}
				isLabelBold
				maxValue={20}
				minValue={1}
				prefix="card"
				updateRangeValue={(value: number) => updateMainFormField({ cardCount: value })}
				value={cardCount}
			/>
		</>
	);
};
